export default {
  container: {
    display: 'none',
    width: '200px',
    background: '#fff',
    height: '100%',
    position: 'absolute',
    right: '0',
    top: '0',
    borderLeft: '1px solid #ececec',
    transform: 'translateX(130px)',
    transition: 'transform 0.3s',
    padding: '20px',
    [`@media (max-width: 920px) and (orientation: landscape)`]: {
      display: 'block'
    }
  },
  opened: {
    transform: 'translateX(0)'
  }
}
